import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'hr_RS',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  'c968e895-49a5-4423-aec9-f8ebefba1212',
  ''
);
